import type { InjectionKey } from 'vue';

export interface GoodsInfoContext {
  status?: number;
}

export const goodsInfoInjectionKey: InjectionKey<GoodsInfoContext> =
  Symbol('goodsInfoInjectionKey');

export interface PayBarTrackingOptionsContext {
  scope?: string;
  name?: string;
  entry?: string;
  biJson?: Record<string, any>;
}

export const payBarTrackingOptionsInjectionKey: InjectionKey<PayBarTrackingOptionsContext> = Symbol(
  'payBarTrackingOptionsInjectionKey',
);
